// Internal application semantic features (Anti-Corruption Layer)
export const PermissionFeature = {
  RoutingProtocol: 'RoutingProtocol',
  RateManagement: 'RateManagement',
} as const;

export type PermissionFeatureType =
  (typeof PermissionFeature)[keyof typeof PermissionFeature];

// Internal application semantic actions
export const PermissionAction = {
  Create: 'Create',
  Search: 'Search',
  View: 'View',
  Edit: 'Edit',
  Clone: 'Clone',
  Export: 'Export',
  Import: 'Import',
  Delete: 'Delete',
  Renew: 'Renew',
  Publish: 'Publish',
} as const;

export type PermissionActionType =
  (typeof PermissionAction)[keyof typeof PermissionAction];

// Strictly typed permission map mapping internal features to allowed internal actions
export type PermissionMap = Partial<
  Record<PermissionFeatureType, PermissionActionType[]>
>;
